export enum PartyAddressTypeEnum {
  Company,
  Terminal,
  Depot
}
